
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 14h6v-4h2V4H13.32C12.17 1.58 9.72 0 7 0 3.14 0 0 3.14 0 7s3.14 7 7 7c2.72 0 5.18-1.58 6.32-4H16v4zm4-2h-2V8h-6.06l-.23.67C11.01 10.66 9.11 12 7 12c-2.76 0-5-2.24-5-5s2.24-5 5-5c2.11 0 4.01 1.34 4.71 3.33l.23.67H22v2h-2v4zM7 10c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zM6 7c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1z","fill":"#585858"}})])
          )
        }
      }
    